import React from 'react';
import './App.css';
import BackButton from './BackButton';

/*
  Support contact page.

  The in-app Asana support path is temporarily disabled: the service account
  is a Commenter in Asana (least privilege), and the old form wrote to a
  custom field, which needs the Editor role. Until that endpoint is changed
  to post a comment instead (see docs/INTERN_TODO.md item 10), support is a
  plain mailto.

  The subject carries a fixed [Dealer Photo App] tag so every message from
  this app lands the same way and is trivial to filter with one mailbox rule
  (Outlook: "subject contains [Dealer Photo App]" -> Dealer Photo App folder).
  Keep that tag stable; the mailbox rule depends on it.
*/

const SUPPORT_EMAIL = 'dealersupport@evnusa.com';
const SUBJECT = '[Dealer Photo App] Support request';
const BODY = [
  'Please describe your question or issue below.',
  'Including your brand and Dealer ID helps us respond faster.',
  '',
  'Brand:',
  'Dealer ID:',
  '',
  'Question:',
  '',
].join('\n');

const mailtoHref =
  `mailto:${SUPPORT_EMAIL}` +
  `?subject=${encodeURIComponent(SUBJECT)}` +
  `&body=${encodeURIComponent(BODY)}`;

function Support() {
  return (
    <div className="Support">
      <h1 className="Support-title">Have a question? We're here to help</h1>
      <p className="Support-text">
        Email our dealer support team and we'll get back to you. Tapping the
        button opens a pre-addressed message in your mail app — just add your
        brand, Dealer ID, and question.
      </p>
      <a className="submit-button" href={mailtoHref}>
        Email Dealer Support
      </a>
      <p className="Support-text">
        Or write to us directly at{' '}
        <a href={mailtoHref}>{SUPPORT_EMAIL}</a>.
      </p>
      <BackButton />
    </div>
  );
}

export default Support;
